import { LitElement, html, css } from "lit";
import { customElement, property, state } from "lit/decorators.js"
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { HashLinkMixin } from "src/mixins/HashLinkMixin";
import { standardMarkdownTheme } from "src/styles/markdown-theme";

import  "src/components/markdown-components"

@customElement("markdown-content")
export class MarkdownContent extends HashLinkMixin(LitElement){
  static styles = [
    css`
      :host, #wrapper {
        display: contents
      }

    `
    , standardMarkdownTheme];

  @property() htmlContent: string = "";

  render = () => html`<span id="wrapper" class="standard-markdown">${unsafeHTML(this.htmlContent)}</span>`;
}

declare global {
  interface HTMLElementTagNameMap {
    "markdown-content": MarkdownContent;
  }
}
